import { useMemo } from "react";
import useAZZKUProfessions from "hooks/AZZKU/useAZZKUProfessions";
import useAZZKUIndustries from "hooks/AZZKU/useAZZKUIndustries";

import ProfessionItem from "components/ProfessionItem";
import AddProfessionForm from "./components/AddProfessionForm";
import SearchProfessionForm from "./components/SearchProfessionForm";
import Loader from "components/Loader";

export default function ProfessionsForms({ params, errors, hide_text, onChange }) {

   const { d: industries } = useAZZKUIndustries();
   const { d: professions_options } = useAZZKUProfessions();
   const profession_ids = params.profession_ids || [];
   
   const professions = useMemo(() => {
      if( !professions_options ) return null;
      return profession_ids.map( id => professions_options?.find( p => +p.value === +id ))
   }, [ professions_options, profession_ids ]);

   const onAdd = prof_id => {
      if ( !prof_id || profession_ids.includes( +prof_id )) return;
      onChange({ profession_ids: [...profession_ids, +prof_id ]});
   }

   const onDelete = prof_id => {
      onChange({ profession_ids: profession_ids.filter( id => +id !== +prof_id )});
   }

   return professions_options && industries ? (
      <>
         <AddProfessionForm 
            hide_text={ hide_text }
            industries={ industries }
            professions_options={ professions_options }
            onSubmit={ p => onAdd( p )}
         />

         <div> lub </div>

         <SearchProfessionForm onSubmit={ p => onAdd( p )}/>

         { !!professions.length && 
            <div style={{
               display: "flex",
               flexWrap: "wrap",
               gap: "14px"
            }}> 
               { professions.map( p => (
                  <ProfessionItem
                     key={ p.value }
                     label={ p.label }
                     onDelete={() => onDelete( p.value )}
                  />
               ))}
            </div>
         }

         { errors?.profession_ids && <div className="error"> { errors.profession_ids } </div> }
      </>
   ) : <Loader/>
}